export const dimensions = {
  spacing: {
    none: 0,
    xs: 2,
    sm: 4,
    md: 6,
    lg: 8,
    xl: 12,
    '2xl': 16,
    '3xl': 24,
    '4xl': 32
  },
  radius: {
    sm: 3,
    md: 4,
    lg: 6,
    xl: 8,
    pill: 9999
  },
  size: {
    iconXs: 11,
    iconSm: 14,
    iconMd: 16,
    iconLg: 20,
    iconXl: 24
  },
  logo: {
    headerHeight: 22
  },
  controlHeight: {
    xs: 32,
    sm: 40,
    lg: 48
  }
} as const;
